export class PaginationModel {
    constructor(page: number, pageLength: number, totalRecords : number, filteredRecords? : number) {
        this.page = page;
        this.pageLength = pageLength;
        this.recordCount = totalRecords;
        this.filteredCount = filteredRecords;
    }

    public page : number;
    public pageLength : number;
    public recordCount : number;
    public filteredCount? : number;
}
